import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { IconClose } from '../Icons';

import { StyledModalWrapper, StyledModal, StyledCloseButton } from './ModalStyles';

var _ref2 = React.createElement(IconClose, null);

var Modal = function Modal(props) {
  var modalWrapperRef = useRef(null);
  var modalRef = useRef(null);

  useEffect(function () {
    // add focus to modal when active for accessibility
    if (props.active && modalRef.current) {
      modalRef.current.focus();
    }
  }, [props.active]);

  var closeModal = function closeModal(e) {
    if (e.target == modalWrapperRef.current && props.closeOnOutsideClick) {
      props.closeModalFunc();
    }
  };

  var handleKeyDown = function handleKeyDown(_ref) {
    var keyCode = _ref.keyCode;

    // pressed escape, close modal
    keyCode === 27 && props.closeModalFunc();
    return false;
  };

  if (props.active) {
    return React.createElement(
      StyledModalWrapper,
      {
        className: props.className,
        active: props.active,
        onClick: closeModal,
        ref: modalWrapperRef,
        'data-service-hide-element': 'true' // hide all modals when thumbnail servive is rendering pages
      },
      React.createElement(
        StyledModal,
        {
          ref: modalRef,
          tabIndex: '-1',
          'aria-modal': 'true',
          onKeyDown: function onKeyDown(e) {
            return handleKeyDown(e);
          },
          modalHeight: props.modalHeight ? props.modalHeight : 'initial',
          modalWidth: props.modalWidth ? props.modalWidth : '450px',
          dataCapture: props.dataCapture
        },
        props.children,
        React.createElement(
          StyledCloseButton,
          {
            onClick: function onClick() {
              return props.closeModalFunc();
            },
            'aria-label': 'Close Modal'
          },
          _ref2
        )
      )
    );
  } else {
    return null;
  }
};

Modal.propTypes = {
  closeModalFunc: PropTypes.func,
  closeOnOutsideClick: PropTypes.bool.isRequired,
  active: PropTypes.bool.isRequired,
  className: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.array, PropTypes.object])
};

Modal.defaultProps = {
  closeOnOutsideClick: true
};

export default Modal;